import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchBiens } from '../biensSlice'
import { useBienContext } from "../BienContext"
import { EmptyValuePlaceholder, SectionPanel, Spinner } from '@/components/ui'
import { formatPrice, formatSurface } from '@/utils/formatters'


const UniteItem = ({bien}) => {

  const handleRowClick = (bienId) => {
    window.location.href = `/biens/${bienId}` // Rediriger vers la page de détails du bien cliqué
  }

  return (
    <tr onClick={() => handleRowClick(bien.id)}
        className='cursor-pointer hover:bg-primary-200'
    >
      <td><EmptyValuePlaceholder value={bien.numero_appartement}/></td>
      <td>
        { bien.mandats.length < 2 && <EmptyValuePlaceholder value={bien.mandats[0]?.numero} />  }
        { bien.mandats.length > 1 && 
            <div className='flex flex-col'>{
              bien.mandats.map((mandat, i) => (
                  <div key={i} className={`${mandat.actif ? "" : "italic"}`}>
                    {mandat.numero}
                    {!mandat.actif && <span className="ml-2">fin le {formatDate(mandat.date_fin)}</span>}
                  </div>
                ))
            }</div>
        }
      </td>
      <td>
        <EmptyValuePlaceholder value={formatPrice(bien.prix_loyer)}/>
      </td>
      <td>
        <EmptyValuePlaceholder value={formatPrice(bien.charges)}/>
      </td>
      <td>
        <EmptyValuePlaceholder value={formatSurface(bien.surface_carrez)}/>
      </td>
      <td>
        { bien.proprietaires?.map((prop, i) => <div key={i} className="uppercase">{prop.nom_complet}</div>) }
      </td>
      <td>
        { bien.locataires?.map((loc, i) => <div key={i} className="uppercase">{loc.nom_complet}</div>) }
      </td>
    </tr>
  )
}

export default () => {
  const dispatch = useDispatch()
  const { bien } = useBienContext()
  const unites = useSelector(state => state.biens.items)
  const isLoading = useSelector(state => state.biens.loadingStatus.fetchList)
 
  useEffect(
    () => {
      if(bien?.id) {
        dispatch(fetchBiens({immeuble_id: bien.id}))
      }
    },
    [bien.id]
  )

  return (
    <SectionPanel>
      <SectionPanel.Title title="Locations" />
      <div className='card-body p-0 rounded-none'>
        <table className="table table-zebra w-full">
          <thead>
            <tr>
              <th>N° appt</th>
              <th>Mandat</th>
              <th>Loyer</th>
              <th>Charges</th>
              <th>Surface</th>
              <th>Propriétaire</th>
              <th>Locataire</th>
            </tr>
          </thead>
          <tbody>
            { isLoading && <tr><td colSpan="5" className="text-center"><Spinner color='gray-600'/></td></tr> }
            {(!isLoading && (!unites || unites.length === 0)) && 
              <tr>
                <td colSpan="8" className="text-center text-gray-600 italic py-4">
                  Aucun appartement lié
                </td>
              </tr>
            } 
            {(!isLoading && unites.length > 0) &&
              [...unites]
                .sort((a, b) => {
                  // Si a n'a pas de numéro de mandat, il va après b
                  if (!a.numero_mandats || a.numero_mandats.length === 0) return 1
                  // Si b n'a pas de numéro de mandat, il va après a
                  if (!b.numero_mandats || b.numero_mandats.length === 0) return -1
                  
                  // Comparer le premier numéro de mandat disponible
                  const mandatA = a.numero_mandats[0]
                  const mandatB = b.numero_mandats[0]

                  if(mandatA.length === 0) return 1
                  if(mandatB.length === 0) return -1
                  
                  // Comparaison numérique si les deux sont des nombres
                  if (!isNaN(mandatA) && !isNaN(mandatB)) {
                    return Number(mandatA) - Number(mandatB)
                  }
                  
                  // Comparaison alphabétique sinon
                  return String(mandatA).localeCompare(String(mandatB))
                })
                .map((item, index) => <UniteItem bien={item} key={index} />)
            }
          </tbody>
        </table>
      </div>
    </SectionPanel>
  )
}
